import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-form-text-area',
  templateUrl: './form-text-area.component.html',
  styleUrls: ['./form-text-area.component.scss']
})
export class FormTextAreaComponent implements OnInit, OnChanges {
  @Input() customLabel: boolean = false;

  @Input() disabled: boolean = false;

  @Input() inputName: string = `v6-${Math.random().toString(36).slice(2)}`;

  @Input() label: string

  @Input() helpText: string;

  @Input() model: string;

  @Input() placeholder: string = '';

  @Input() rows: number = 3;

  @Output() modelChange: EventEmitter<string> = new EventEmitter<string>();

  inputValue: string;

  constructor() { }

  ngOnInit(): void {
    this.assignFormInputValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.model){
      this.assignFormInputValue();
    }
  }

  assignFormInputValue() {
    this.inputValue = this.model;
  }

  updateFormInputValue() {
    this.modelChange.emit(this.inputValue);
  }
}
